import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../cn';

const flatButtonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap font-bold border-2 border-black bg-[#fcfbfa] text-black rounded-lg text-sm capitalize with-hover:hover:bg-yellow-t2 active:bg-yellow-t1 disabled:opacity-50 disabled:pointer-events-none',
  {
    variants: {
      size: {
        default: 'px-3 py-2',
        icon: 'size-10 p-2',
        mobileIcon: 'size-[34px] p-1.5 border-0',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
);

export interface FlatButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof flatButtonVariants> {
  asChild?: boolean;
}

const FlatButton = React.forwardRef<HTMLButtonElement, FlatButtonProps>(
  ({ className, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return <Comp className={cn(flatButtonVariants({ size, className }))} ref={ref} {...props} />;
  }
);
FlatButton.displayName = 'FlatButton';

export { FlatButton, flatButtonVariants };
